'use client'

import {
  Button,
  Flex,
  Heading,
  Image,
  Stack,
  Text,
  useBreakpointValue,
} from '@chakra-ui/react'
import {useNavigate} from "react-router-dom";
import gif from "../../assets/img/404_inohom_2.gif"

export default function SplitScreen() {
  const navigate = useNavigate();
  const handleGoHome = () => { navigate('/'); };
  return (
    <Stack minH={'100vh'} direction={{ base: 'column', md: 'row' }}>
      <Flex p={8} flex={1} align={'center'} justify={'center'}>
        <Stack spacing={6} w={'full'} maxW={'lg'}>
          <Heading fontSize={{ base: '3xl', md: '4xl', lg: '5xl' }}>
            <Text
              as={'span'}
              position={'relative'}
              _after={{
                content: "''",
                width: 'full',
                height: useBreakpointValue({ base: '20%', md: '30%' }),
                position: 'absolute',
                bottom: 1,
                left: 0,
                bg: 'red.400',
                zIndex: -1,
              }}>
              Oops.....
            </Text>
            <br />{' '}
            <Text color={'red.600'} as={'span'}>
              Üzgünüz, Aradığınız sayfaya ulaşamadık
            </Text>{' '}
          </Heading>
          <Text fontSize={{ base: 'md', lg: 'lg' }} color={'gray.500'}>
            404 Page Not Found
          </Text>
          <Stack direction={{ base: 'column', md: 'row' }} spacing={4}>
            <Button
              onClick={handleGoHome}
              rounded={'full'}
              bg={'red.600'}
              color={'white'}
              _hover={{
                bg: 'green.500',
              }}>
              Ana sayfaya dön
            </Button>

          </Stack>
        </Stack>
      </Flex>
      <Flex flex={2}>
       
          <Image
            mt={10}
            boxSize='85%'
            alt={'Login Image'}
            objectFit={'cover'}
            src={gif}
          />
       
        
      </Flex>
    </Stack>
  )
}
